/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import NavigationBar from '../components/NavBar'
import { Link } from 'react-router-dom';
import Dropdown from 'react-dropdown'
import FormsDocuments from '../components/FormsDocuments'
import GoogleZoom from '../components/GoogleZoom'
// import ComplianceComponent from '../components/ComplianceComponent'
import { useSelector, useDispatch } from 'react-redux';
import { 
    selectDrivers,
    addDrivers
} from '../features/drivers/driversSlice'

var outsideCity = "None"
    // get the week function
// eslint-disable-next-line no-extend-native
Date.prototype.getWeek = function () {
    var firstDate = new Date(this.getFullYear(), 0, 1)
    if (this.getFullYear() === 2021) {
        return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
    } else {
        return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
    }
}

const determineOffboarded = (offboradedContent) => {
    switch (offboradedContent) {
        case 'OffboardedForever':
            return false
        case 'Active':
            return true
        case 'verified':
            return true
        case null:
            return true        
        default:
            return false;
    }
}
const determineOffboardedOpposite = (offboradedContent) => {
    switch (offboradedContent) {
        case 'OffboardedForever':
            return true
        case 'Active':
            return false
        case 'verified':
            return false
        case null:
            return false        
        default:
            return true;
    }
}

var driverSelected = null
const Compliance = (props) => {
    var CryptoJS = require("crypto-js");
    const [ content, setContent ] = useState(null)
    const [ selectedCity, setSelectedCity ] = useState('DBS2')
    const [ selectedCitySubmit, setSelectedCitySubmit ] = useState('DBS2')
    const [ logicalGate, setLogicalGate ] = useState(false)
    const [ submitPressed, setSubmitPressed ] = useState('Submit')
    const [ submitPressedEdit, setSubmitPressedEdit ] = useState('Submit')
    const [ data, setData ] = useState(null)
    const [ nonActiveDrivers, setNonActiveDrivers ] = useState([])
    const [ nonVerifiedImages, setNonVerifiedImages ] = useState([])
    const [ vanList, setVanList ] = useState([])
    const [ selectedDriver, setSelectedDriver ] = useState(null)
    const [ reload, setReload ] = useState(0)
    const [ editGate, setEditGate ] = useState(false)
    const [ offboardGate, setOffboardGate ] = useState(false)
    const [ offboardDriver, setOffboardDriver ] = useState(null)
    const [ errorMessage, setErrorMessage ] = useState(null)
    const [ drivers, setDrivers ] = useState([])
    const [ images, setImages ] = useState([])
    const [ imageSelectedOffboard, setImageSelectedOffboard ] = useState(false)
    const [ selectedOffboardImage, setSelectedOffboardImage ] = useState('')

    // drivers changing stations
    const [stationChangers, setStationChangers] = useState([])
    const [stationChangerList, setStationChangerList] = useState([])

    // redux drivers
    const reduxDrivers = useSelector(selectDrivers)

    // redux set state
    useEffect( () => {
        if (reduxDrivers.length > 0) {
            // set the drivers
            let localDrivers = [...reduxDrivers]
            localDrivers.sort( (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1: -1))
            setDrivers(localDrivers)
        } else {
            setReload(reload + 1)
        }
    }, [reduxDrivers])
    
    // redux stuff
    const dispatch = useDispatch()

    // get function
    async function getData(url = '') {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
        })
        return response ? response.json() : console.log('no reponse')
    };
    async function putData(url = '', data={}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'PUT', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
        })
        return response ? response.json() : console.log('no reponse')
    };
    useEffect( () => {
        getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
            response.results.sort( (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1: -1))
            dispatch(addDrivers(response.results))
        })
    }, [reload])

    var editTheDriver;

    useEffect( () => {
        driverSelected = selectedDriver
    }, [selectedDriver])

    useEffect( () => {
        getData('https://backendpajamas.herokuapp.com/managerchange/').then( response => {
            console.log(response)
            setStationChangers(response.results)
        })
    }, [])

    // set the doc drivers into state
    // useEffect( () => {
    //     if (reduxDocDrivers[selectedCity]) {
    //         let localObj = {...reduxDocDrivers[selectedCity]}
    //         let localObjDrivers = [...localObj.drivers]
    //         localObjDrivers.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
    //         setData(localObj)
    //     }
    //     console.log(reduxDocDrivers)
    // }, [reduxDocDrivers, selectedCity])

    // grab the main data
    // useEffect(() => {
    //     async function postData(url = '', data = {}) {
    //         let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
    //         let originalText = bytes.toString(CryptoJS.enc.Utf8);
    //         const response = await fetch(url, {
    //             method: 'POST', 
    //             mode: 'cors',
    //             cache: 'no-cache',
    //             credentials: 'same-origin',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Token ${originalText}`
    //             },
    //             body: JSON.stringify(data)
    //             });

    //         return response ? response.json() : console.log('no reponse')
    //     };

    //     postData('https://backendpajamas.herokuapp.com/docdrivers/', {
    //         station: selectedCity
    //     }).then( response => {
    //         let name = selectedCity
    //         let myObj = {}
    //         myObj[`${name}`] = response.data
    //         dispatch(addDocDriver({
    //             payload: myObj[`${name}`],
    //             name: `${name}`
    //         }))
    //     })
    // }, [reload])

    // faster load
    // useEffect( () => {
    //     async function getData(url = '') {
    //         let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
    //         let originalText = bytes.toString(CryptoJS.enc.Utf8);
    //         const response = await fetch(url, {
    //             method: 'GET', 
    //             mode: 'cors',
    //             cache: 'no-cache',
    //             credentials: 'same-origin',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Token ${originalText}`
    //             },
    //         });

    //         return response ? response.json() : console.log('no reponse')
    //     };

    //     getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
    //         setDrivers(response.results)
    //         getData('https://backendpajamas.herokuapp.com/images/').then( response => {
    //             setImages(response.results)
    //         })
    //     })
    // }, [])

    // render components 
    // useEffect( () => {
    //     let localArray = []
    //     if (drivers.length > 0 && images.length > 0) {
    //         drivers.forEach( (ele, id) => {
    //             localArray.push(
    //                 <SubComponentDocument 
    //                     ele={ele}
    //                     selectedCity={selectedCity}
    //                     images={images}
    //                     handleClick={handleClick}
    //                 />
    //             )
    //         setDriverList(localArray)
    //     })
    //     }
    // }, [drivers, images, selectedCity])

    // map the non active drivers to list
    useEffect( () => {
        let x = 0
        let y = 0
        let z = 0
        let localArray = []
        let localVerifiedArray = []
        let localStationChangeList = []
        if (drivers.length > 0) {
            let stationChangeList = []
            if (stationChangers.length > 0) {
                stationChangers.forEach( ele => {
                    if (!stationChangeList.includes(ele.driver_id)) {
                        stationChangeList.push(ele.driver_id)
                    }
                })
            }
            drivers.forEach( (driver, driverID) => {
                if (stationChangeList.includes(driver.driver_id.toString())) {
                    localStationChangeList.push(
                        <div key={driver.driver_id}>
                            <h3 key={driverID} className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectDriver(e, driver)}>
                                {z+1}. {driver.name}
                            </h3>
                            <br />
                        </div>
                    )
                    z++
                } else {
                    if (determineOffboarded(driver.status)) {
                        if (driver.status) {
                            if (driver.status !== 'verified' && driver.location === selectedCity) {
                                localArray.push(
                                    <div key={driver.driver_id}>
                                        <h3 key={driverID} className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectDriver(e, driver)}>
                                            {x+1}. {driver.name}
                                        </h3>
                                        <br />
                                    </div>
                                )
                                x++
                            } else if (driver.status === 'verified' && driver.location === selectedCity) {
                                if (driver.offBoard) {
                                    localVerifiedArray.push(
                                        <div key={driver.driver_id} id='offBoardPending'>
                                            <h3 key={driverID} className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectDriver(e, driver)}>
                                                {y+1}. {driver.name} {driver.offBoard ? `| ${new Date(driver.offBoard).toLocaleDateString()}`: null}
                                            </h3>
                                            <br />
                                        </div>
                                    )
                                } else {
                                    localVerifiedArray.push(
                                        <div key={driver.driver_id}>
                                            <h3 key={driverID} className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectDriver(e, driver)}>
                                                {y+1}. {driver.name}
                                            </h3>
                                            <br />
                                        </div>
                                    )
                                }
                                y++
                            }
                        }
                        if (!driver.status && driver.location === selectedCity) {
                            localArray.push(
                                <div key={driver.driver_id}>
                                    <h3 key={driverID} className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectDriver(e, driver)}>
                                        {x+1}. {driver.name}
                                    </h3>
                                    <br />
                                </div>
                            )
                            x++
                        }
                    }
                }
            })
        }
        setNonVerifiedImages(localVerifiedArray)
        setNonActiveDrivers(localArray)
        setStationChangerList(localStationChangeList)
        // eslint-disable-next-line react-hooks/exhaustive-deps
        driverLocalList = localArray
    }, [drivers, selectedCity, stationChangers])

    // function for changing the city from dropdown
    const handleSelectCity = (e, selectCity) => {
        setSelectedCity(selectCity)
    }
    
    // send form to backend
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitPressed('Created')
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });
            
            return response ? response.json() : console.log('no reponse')

        };

        postData('https://backendpajamas.herokuapp.com/drivers/', {
            name: e.target.name.value !== null ? e.target.name.value : 'None',
            address: e.target.address.value ? e.target.address.value : 'None',
            location: outsideCity ? outsideCity : 'None',
            phone: e.target.mobile.value ? e.target.mobile.value : 'None',
            email: e.target.email.value ? e.target.email.value : 'None',
            DriverUniqueId: e.target.UTRNumber.value ? e.target.UTRNumber.value : 'None',
        }).then( (response) => {
            backToNormal()
            let x = reload
            let y = x + 1
            setReload(y)
            setSubmitPressed('Submit')
            // handle the drivers
            getData('https://backendpajamas.herokuapp.com/drivers/').then( responseTwo => {
                if (responseTwo !== undefined) {
                    dispatch(addDrivers(responseTwo.results))
                }
            })
        })
    }

    useEffect( ( ) => {
        outsideCity = selectedCitySubmit
    }, [selectedCitySubmit])

    // send form to backend editing
    const handleSubmitEdit = (e) => {
        e.preventDefault();
        setSubmitPressedEdit('Edited')
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });
            return response ? response.json() : console.log('no reponse')
        };
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });
            return response ? response.json() : console.log('no reponse')
        };
        if (selectedDriver.location !== selectedCitySubmit) {
            postData('https://backendpajamas.herokuapp.com/managerchange/', {
                date: new Date(),
                week_number: new Date().getWeek(),
                station: selectedCitySubmit,
                driver_id: selectedDriver.driver_id
            })
        }

        putData(`https://backendpajamas.herokuapp.com/drivers/${selectedDriver.driver_id}/`, {
            name: e.target.name.value ? e.target.name.value : 'null',
            // location: selectedCitySubmit ? selectedCitySubmit : 'null',
            address: e.target.address.value ? e.target.address.value : 'null',
            phone: e.target.mobile.value ? e.target.mobile.value : 'null',
            email: e.target.email.value ? e.target.email.value : 'null',
            DriverUniqueId: e.target.UTRNumber.value ? e.target.UTRNumber.value : 'null',
        }).then( (response) => {
            backToNormal()
            let x = reload
            let y = x + 1
            setReload(y)
            setSubmitPressedEdit('Submit')
            // handle the drivers
            getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
                dispatch(addDrivers(response.results))
            })
        })
    }

    // reset the page
    const backToNormal = () => {
        setLogicalGate(false)
        setEditGate(false)
        setOffboardGate(false)
        // setSelectedDriver(null)
    }

    // dropdown menu options a commetn
    const options = [
        'DBS2',
        'DSN1',
        'DEX2',
        'DXP1',
        'DCF1'
    ]

    // function for setting the station
    const onSelect = (e) => {
        setSelectedCitySubmit(e.value)
    }

    // handle reload on submit element
    const handleRelaod = () => {
        let myNum = reload
        setReload(myNum)
    }

    // make the driver page
    var makeTheDriver
    useEffect( () => {
        if (logicalGate) {
            setContent(
                <div className='new_driver_form_container'>
                    <h1>Add Driver</h1>
                    <form onSubmit={handleSubmit} className='new_employee_form'>
                        <div className='dashboard_form_divs_name'>
                            <label className='labels'>Name</label>
                                <input className='inputs' type="text" name='name' id='makeThisMore'/>
                        </div>
                        <div className='dashboard_form_divs_name'>
                            <label className='labels'>Depot</label>
                            <Dropdown 
                                options={options} 
                                onChange={onSelect} 
                                value={selectedCitySubmit} 
                                placeholder="Select an option" 
                                className='drop_down_bar_dashboard'
                                id='drop_down_style'
                            />
                        </div>
                        <div className='dashboard_form_divs_name'>
                            <label className='labels'>Address</label>
                                <input className='inputs' type="text" name='address'/>
                        </div>
                        <div className='dashboard_form_divs_name'>
                            <label className='labels'>Mobile</label>
                                <input className='inputs' type="tel" name='mobile' placeholder='Format: 01234567890' pattern="[0-9]{11}" />
                        </div>
                        <div className='dashboard_form_divs_name'>
                            <label className='labels'>Email</label>
                                <input className='inputs' type="email" name='email' required/>
                        </div>
                        <div className='dashboard_form_divs_name'>
                            <label className='labels'>UTR Number</label>
                                <input className='inputs' type="text" name='UTRNumber' placeholder='Format: 0123456789' pattern="[0-9]{10}"/>
                        </div>
                        <div className='buttons_new_driverPage'>
                            <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                            <button className='compliance_add_driver_button_submit' onClick={backToNormal}>
                                <span className='span_in_complaince_button'>Return</span> 
                            </button>
                        </div>
                    </form>
                </div>
            )
        }
    }, [logicalGate])

    // edit Gate
    useEffect ( () => {
        if (editGate) {
            if (selectedDriver) {
                let stationChangeList = []
                if (stationChangers.length > 0) {
                    let changeBool = null
                    stationChangers.forEach( ele => {
                        if (ele.driver_id === selectedDriver.driver_id.toString()) {
                            changeBool = ele
                        }
                    })
                    if (changeBool) {
                        setContent(
                            <div className='new_driver_form_container_edit'>
                                <div className='leftContentEditPage'>
                                    <h1>Edit Driver</h1>
                                    <form onSubmit={handleSubmitEdit} className='edit_employee_form'>
                                        <div className='dashboard_form_divs_name'>
                                            <label className='labels'>Name</label>
                                                <input className='inputs' type="text" name='name' defaultValue={selectedDriver.name}/>
                                        </div>
                                        <div className='dashboard_form_divs_name'>
                                            Pending Change: {selectedDriver.location} to {changeBool.station}
                                        </div>
                                        <div className='dashboard_form_divs_name'>
                                            <label className='labels'>Address</label>
                                                <input className='inputs' type="text" name='address' defaultValue={selectedDriver.address !== 'null' ? selectedDriver.address : ''}/>
                                        </div>
                                        <div className='dashboard_form_divs_name'>
                                            <label className='labels'>Mobile</label>
                                                <input className='inputs' type="tel" name='mobile' placeholder='Format: 01234567890' pattern="[0-9]{11}" defaultValue={selectedDriver.phone !== 'null' ? selectedDriver.phone : ''} />
                                        </div>
                                        <div className='dashboard_form_divs_name'>
                                            <label className='labels'>Email</label>
                                                <input className='inputs' type="email" name='email' defaultValue={selectedDriver.email} required/>
                                        </div>
                                        <div className='dashboard_form_divs_name'>
                                            <label className='labels'>UTR Number</label>
                                                <input className='inputs' type="text" name='UTRNumber' defaultValue={selectedDriver.DriverUniqueId !== 'null' ? selectedDriver.DriverUniqueId : ''} placeholder='Format: 0123456789' pattern="[0-9]{10}"/>
                                        </div>
                                        <div className='buttons_new_driverPage'>
                                            <input type="submit" value={submitPressedEdit} className='compliance_add_driver_button_submit' />
                                            <button className='compliance_add_driver_button_submit' onClick={backToNormal}>
                                                <span className='span_in_complaince_button'>Return</span> 
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <div className='rightContentEditPage'>
                                    <FormsDocuments 
                                        selectedDriver={selectedDriver}
                                        superUser={props.superUser ? true : false}
                                        station={props.station}
                                        fromDocument={false}
                                        handleReload={handleRelaod}
                                        data={data}
                                    />
                                </div>
                            </div>
                        )
                    } else {
                        setContent(
                            <div className='new_driver_form_container_edit'>
                                <div className='leftContentEditPage'>
                                    <h1>Edit Driver</h1>
                                    <form onSubmit={handleSubmitEdit} className='edit_employee_form'>
                                        <div className='dashboard_form_divs_name'>
                                            <label className='labels'>Name</label>
                                                <input className='inputs' type="text" name='name' defaultValue={selectedDriver.name}/>
                                        </div>
                                        <div className='dashboard_form_divs_name'>
                                            <label className='labels'>Depot</label>
                                            <Dropdown 
                                                options={options} 
                                                onChange={onSelect} 
                                                value={selectedCitySubmit} 
                                                placeholder="Select an option" 
                                                className='drop_down_bar_dashboard'
                                                id='drop_down_style'
                                            />
                                        </div>
                                        <div className='dashboard_form_divs_name'>
                                            <label className='labels'>Address</label>
                                                <input className='inputs' type="text" name='address' defaultValue={selectedDriver.address !== 'null' ? selectedDriver.address : ''}/>
                                        </div>
                                        <div className='dashboard_form_divs_name'>
                                            <label className='labels'>Mobile</label>
                                                <input className='inputs' type="tel" name='mobile' placeholder='Format: 01234567890' pattern="[0-9]{11}" defaultValue={selectedDriver.phone !== 'null' ? selectedDriver.phone : ''} />
                                        </div>
                                        <div className='dashboard_form_divs_name'>
                                            <label className='labels'>Email</label>
                                                <input className='inputs' type="email" name='email' defaultValue={selectedDriver.email} required/>
                                        </div>
                                        <div className='dashboard_form_divs_name'>
                                            <label className='labels'>UTR Number</label>
                                                <input className='inputs' type="text" name='UTRNumber' defaultValue={selectedDriver.DriverUniqueId !== 'null' ? selectedDriver.DriverUniqueId : ''} placeholder='Format: 0123456789' pattern="[0-9]{10}"/>
                                        </div>
                                        <div className='buttons_new_driverPage'>
                                            <input type="submit" value={submitPressedEdit} className='compliance_add_driver_button_submit' />
                                            <button className='compliance_add_driver_button_submit' onClick={backToNormal}>
                                                <span className='span_in_complaince_button'>Return</span> 
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <div className='rightContentEditPage'>
                                    <FormsDocuments 
                                        selectedDriver={selectedDriver}
                                        superUser={props.superUser ? true : false}
                                        station={props.station}
                                        fromDocument={false}
                                        handleReload={handleRelaod}
                                        data={data}
                                    />
                                </div>
                            </div>
                        )
                    }
                } else {
                    setContent(
                        <div className='new_driver_form_container_edit'>
                            <div className='leftContentEditPage'>
                                <h1>Edit Driver</h1>
                                <form onSubmit={handleSubmitEdit} className='edit_employee_form'>
                                    <div className='dashboard_form_divs_name'>
                                        <label className='labels'>Name</label>
                                            <input className='inputs' type="text" name='name' defaultValue={selectedDriver.name}/>
                                    </div>
                                    <div className='dashboard_form_divs_name'>
                                        <label className='labels'>Depot</label>
                                        <Dropdown 
                                            options={options} 
                                            onChange={onSelect} 
                                            value={selectedCitySubmit} 
                                            placeholder="Select an option" 
                                            className='drop_down_bar_dashboard'
                                            id='drop_down_style'
                                        />
                                    </div>
                                    <div className='dashboard_form_divs_name'>
                                        <label className='labels'>Address</label>
                                            <input className='inputs' type="text" name='address' defaultValue={selectedDriver.address !== 'null' ? selectedDriver.address : ''}/>
                                    </div>
                                    <div className='dashboard_form_divs_name'>
                                        <label className='labels'>Mobile</label>
                                            <input className='inputs' type="tel" name='mobile' placeholder='Format: 01234567890' pattern="[0-9]{11}" defaultValue={selectedDriver.phone !== 'null' ? selectedDriver.phone : ''} />
                                    </div>
                                    <div className='dashboard_form_divs_name'>
                                        <label className='labels'>Email</label>
                                            <input className='inputs' type="email" name='email' defaultValue={selectedDriver.email} required/>
                                    </div>
                                    <div className='dashboard_form_divs_name'>
                                        <label className='labels'>UTR Number</label>
                                            <input className='inputs' type="text" name='UTRNumber' defaultValue={selectedDriver.DriverUniqueId !== 'null' ? selectedDriver.DriverUniqueId : ''} placeholder='Format: 0123456789' pattern="[0-9]{10}"/>
                                    </div>
                                    <div className='buttons_new_driverPage'>
                                        <input type="submit" value={submitPressedEdit} className='compliance_add_driver_button_submit' />
                                        <button className='compliance_add_driver_button_submit' onClick={backToNormal}>
                                            <span className='span_in_complaince_button'>Return</span> 
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div className='rightContentEditPage'>
                                <FormsDocuments 
                                    selectedDriver={selectedDriver}
                                    superUser={props.superUser ? true : false}
                                    station={props.station}
                                    fromDocument={false}
                                    handleReload={handleRelaod}
                                    data={data}
                                />
                            </div>
                        </div>
                    )
                }
            }
        }
    }, [editGate, selectedCitySubmit])

    const backToOffboard = () => {
        setOffboardDriver(null)
    }

    // onboard the driver
    const onBoardTheDriver = (e, theDriver) => {
         // send form to backend
         const handleSubmit = (e) => {
            async function postData(url = '', data = {}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };

            putData(`https://backendpajamas.herokuapp.com/drivers/${theDriver.driver_id}/`, {
                status: 'Active'
            }).then( (response) => {
                postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                    "driver_id": theDriver.driver_id
                }).then( responseImages => {
                    if (responseImages) {
                        responseImages.data.forEach( image => {
                            if (image.verified === 'offboarded') {
                                putData(`https://backendpajamas.herokuapp.com/images/${image.image_id}/`, {
                                    verified: null
                                })
                            }
                        })
                    }
                })
            backToNormal()
            setErrorMessage(null)
            let x = reload
            let y = x + 1
            setReload(y)
            })
        }
        handleSubmit()
    }

    // return the screen to normal
    const handleReturn = () => {
        setErrorMessage(null)
    }

    // ask if they are sure
    const onboard = (e, theDriver) => {
        setErrorMessage(
            <div className='makeMeBigTwo'> 
                <div className='deletionObjectionTwo'>
                    would you like to onboard {theDriver.name}?
                    <div>
                        <button className='deleteButton' onClick={() => onBoardTheDriver(e, theDriver)}>OnBoard</button> 
                        <button className='returnButton' onClick={handleReturn}>Return</button> 
                    </div>
                </div>
            </div>
        )
    }

    // if Offboard Gate
    var OffboardContent
    useEffect( () => {
        const handleSelectDoc = (e, theImage) => {
            setImageSelectedOffboard(true)
            setSelectedOffboardImage(theImage)
        }

        const handleReturnToOffboard = () => {
            setImageSelectedOffboard(false)
            setSelectedOffboardImage('')
        }

        if (offboardGate) {
            if (imageSelectedOffboard) {
                setContent(
                    <div className='selectedOffboardedDriver'> 
                        <div className='spaceMeOutALittleOffboardo'>
                            <GoogleZoom img={selectedOffboardImage}/>
                        </div>
                        <div className='moveReturnButtonDown'>
                            <button className='compliance_add_driver_button_submit' onClick={handleReturnToOffboard} id='returnButtonStyle'>
                                <span className='span_in_complaince_button'>Return</span> 
                            </button>
                        </div>
                    </div>
                )
            } else {
                let localArray = []
                let dbs2Array = [<h3>DBS2</h3>]
                let dsn1Array = [<h3>DSN1</h3>]
                let dex2Array = [<h3>DEX2</h3>]
                let DCF1Array = [<h3>DCF1</h3>]
                let dxp1Array = [<h3>DXP1</h3>]
                if (drivers) {
                    drivers.forEach( (driver, driverId) => {
                        if (determineOffboardedOpposite(driver.status)) {
                            switch (driver.location) {
                                case "DBS2":
                                    dbs2Array.push(
                                        <div key={driverId}>
                                            <h3 className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectOffboardedDriver(e, driver)}>
                                                {driver.name}
                                            </h3>
                                        </div>
                                    )
                                    break;
                                    case "DSN1":
                                    dsn1Array.push(
                                        <div key={driverId}>
                                            <h3 className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectOffboardedDriver(e, driver)}>
                                                {driver.name}
                                            </h3>
                                        </div>
                                    )
                                    break;
                                case "DEX2":
                                    dex2Array.push(
                                        <div key={driverId}>
                                            <h3 className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectOffboardedDriver(e, driver)}>
                                                {driver.name}
                                            </h3>
                                        </div>
                                    )
                                    break;
                                case "DCF1":
                                    DCF1Array.push(
                                        <div key={driverId}>
                                            <h3 className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectOffboardedDriver(e, driver)}>
                                                {driver.name}
                                            </h3>
                                        </div>
                                    )
                                    break;
                                case "DXP1":
                                    dxp1Array.push(
                                        <div key={driverId}>
                                            <h3 className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectOffboardedDriver(e, driver)}>
                                                {driver.name}
                                            </h3>
                                        </div>
                                    )
                                    break;
                                default:
                                    break;    
                            }
                        }
                    })
                    if (dbs2Array.length > 1) {
                        localArray.push(dbs2Array)
                    }
                    if (dsn1Array.length > 1) {
                        localArray.push(dsn1Array)
                    }
                    if (dex2Array.length > 1) {
                        localArray.push(dex2Array)
                    }
                    if (DCF1Array.length > 1) {
                        localArray.push(DCF1Array)
                    }
                    if (dxp1Array.length > 1) {
                        localArray.push(dxp1Array)
                    }
                }
                if (offboardDriver) {
                    let localImageArray = []
                    async function postData(url = '', data = {}) {
                        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                        let originalText = bytes.toString(CryptoJS.enc.Utf8);
                        const response = await fetch(url, {
                            method: 'POST', 
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Token ${originalText}`
                            },
                            body: JSON.stringify(data)
                            });
            
                        return response ? response.json() : console.log('no reponse')
                    };
                    postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                        "driver_id": offboardDriver.driver_id
                    }).then( response => {
                        response.data.forEach( (image, imageId) => {
                            if ( image.imagesLink.includes('.pdf')) {
                                let pageString = 'pg_1/'
                                let begginingOfUrl = image.imagesLink.slice(0, 53)
                                let endOfUrlUrl = image.imagesLink.slice(53)
                                let endUrlString = begginingOfUrl.concat(pageString).concat(endOfUrlUrl)
                                let pngUrlPdf = endUrlString.replace(/.pdf/, '.png')
                                localImageArray.push(
                                    <div className='imageIconBox' onClick={(e) => handleSelectDoc(e, pngUrlPdf)}>
                                        <p>{image.name}</p>
                                        <img src={pngUrlPdf} className='imageThumbs' alt='not found'/>
                                    </div>
                                )
                            } else {
                                localImageArray.push(
                                    <div className='imageIconBox' onClick={(e) => handleSelectDoc(e, image.imagesLink)}>
                                        <p>{image.name}</p>
                                        <img src={image.imagesLink} className='imageThumbs' alt='not found'/>
                                    </div>
                                )
                            } 
                        })
                    OffboardContent = (
                        <div className='selectedOffboardedDriver'> 
                            <h2>Name: {offboardDriver.name}</h2>
                            <h2>Email: {offboardDriver.email}</h2>
                            <h2>Phone: {offboardDriver.phone}</h2>
                            <h2>Approved Date: {offboardDriver.approvedDateAndTime}</h2>
                            <h2>Documents</h2>
                            <div className='imageArrayLocal'>
                                {localImageArray}
                            </div>
                            <button className='compliance_add_driver_button_submit' onClick={(e, theDriver) => onboard(e, offboardDriver)} id='returnButtonStyle'>
                                <span className='span_in_complaince_button'>Onboard</span> 
                            </button>
                        </div>
                    )
                    setContent(
                        <>
                            <div className='new_driver_form_container'>
                                {errorMessage}
                                <h1>Offboarded Drivers</h1>
                                <div className='offboarded_drivers_style'>
                                    <div className='listOfOffboardedDrivers'> 
                                        {localArray}
                                    </div>
                                    <div>
                                        {OffboardContent}
                                    </div>
                                </div>
                                <button className='compliance_add_driver_button_submit' onClick={backToNormal} id='returnButtonStyle'>
                                    <span className='span_in_complaince_button'>Return</span> 
                                </button>
                            </div>
                        </>
                    )
                })
                } else {
                    setContent(
                        <>
                            <div className='new_driver_form_container'>
                                {errorMessage}
                                <h1>Offboarded Drivers</h1>
                                <div className='offboarded_drivers_style'>
                                    <div className='listOfOffboardedDrivers'> 
                                        {localArray}
                                    </div>
                                    <div>
                                        {OffboardContent 
                                        ? OffboardContent : null}
                                    </div>
                                </div>
                                <button className='compliance_add_driver_button_submit' onClick={backToNormal} id='returnButtonStyle'>
                                    <span className='span_in_complaince_button'>Return</span> 
                                </button>
                            </div>
                        </>
                    )
                }
            }
        }
    }, [offboardGate, errorMessage, offboardDriver, imageSelectedOffboard, selectedOffboardImage])
    

    // select offboarded driver for view
    const handleSelectOffboardedDriver = (e, driver) => {
        setOffboardDriver(driver)
    }

    // set the gate for make driver page
    const handleMakeDriverPage = () => {
        setLogicalGate(true)
    }

    const handleDeleteError = () => {
        setErrorMessage(null)
    }

    // set the gate for edit driver page
    const handleEditClick = (e, theDriver) => {
        if (props.superUser) {
            setEditGate(true)
        } else {
            if (props.station.includes(driverSelected.location) || driverSelected.location === 'DCF1') {
                setEditGate(true)
            } else {
                setErrorMessage(
                    <div className='errorMessageAllPages'>
                        <h3 id='errorMessage'>Please contact supervisor if trying to alter data about driver not in your depot. </h3>
                        <button className='errorButton' onClick={handleDeleteError}>Return</button>
                    </div>
                )
            }
        }
    }

    const handleMakeOffboardSort = () => {
        setOffboardGate(true)
    }

    // select a Driver for editing
    const handleSelectDriver = (e, driverMain) => {
        let x = 0
        let y = 0
        let z = 0
        let localArray = []
        let localVerifiedArray = []
        let localStationChangeList = []
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
            });

            return response ? response.json() : console.log('no reponse')
        };
        if ( driverMain) {
            postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                "driver_id": driverMain.driver_id
            }).then( response => {
                let localDriver = {...driverMain}
                localDriver.imgArray = [...response.data]
                setSelectedDriver(localDriver)
            })
        }
        setSelectedCitySubmit(driverMain.location)
        let stationChangeList = []
        if (stationChangers.length > 0) {
            stationChangers.forEach( ele => {
                if (!stationChangeList.includes(ele.driver_id)) {
                    stationChangeList.push(ele.driver_id)
                }
            })
        }
        drivers.forEach( (driver, driverID) => {
            if (stationChangeList.includes(driver.driver_id.toString())) {
                if (driver.name === driverMain.name) {
                    localStationChangeList.push(
                        <div key={driver.driver_id}>
                            <h3 className='h3_for_compliance_Page_colored' onClick={(e, theDriver) => handleSelectDriver(e, driver)}>
                            {z+1}. {driver.name}
                            </h3>
                            {'    '}
                            <button onClick={(e, driver) => handleEditClick(e, driver)}>edit</button>
                            <br />
                        </div>
                    )
                } else {
                    localStationChangeList.push(
                        <div key={driver.driver_id}>
                            <h3 className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectDriver(e, driver)}>
                            {z+1}. {driver.name}
                            </h3>
                            <br />
                        </div>
                    )
                }
                z++
            } else {
                if (determineOffboarded(driver.status)) {
                    if (driver.name === driverMain.name) {
                        if (driver.status === 'verified' && driver.location === selectedCity) {
                            localVerifiedArray.push(
                                <div key={driver.driver_id}>
                                    <h3 className='h3_for_compliance_Page_colored' onClick={(e, theDriver) => handleSelectDriver(e, driver)}>
                                    {y+1}. {driver.name}
                                    </h3>
                                    {'    '}
                                    <button onClick={(e, driver) => handleEditClick(e, driver)}>edit</button>
                                    <br />
                                </div>
                            )
                            y++
                        } else {
                            localArray.push(
                                <div key={driver.driver_id}>
                                    <h3 className='h3_for_compliance_Page_colored' onClick={(e, theDriver) => handleSelectDriver(e, driver)}>
                                    {x+1}. {driver.name}
                                    </h3>
                                    {'    '}
                                    <button onClick={(e, driver) => handleEditClick(e, driver)}>edit</button>
                                    <br />
                                </div>
                            )
                            x++
                        }
                    } else {
                        if (driver.status && driver.location === selectedCity) {
                            if (driver.status !== 'verified' && determineOffboarded(driver.status)) {
                                localArray.push(
                                    <div key={driver.driver_id}>
                                        <h3 className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectDriver(e, driver)}>
                                        {x+1}. {driver.name}
                                        </h3>
                                        <br />
                                    </div>
                                )
                                x++
                            } else if (driver.status === 'verified' && driver.location === selectedCity) {
                                localVerifiedArray.push(
                                    <div key={driver.driver_id}>
                                        <h3 className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectDriver(e, driver)}>
                                        {y+1}. {driver.name}
                                        </h3>
                                        <br />
                                    </div>
                                )
                                y++
                            }
                        }
                        if (!driver.status && driver.location === selectedCity) {
                            localArray.push(
                                <div key={driver.driver_id}>
                                    <h3 className='h3_for_compliance_Page' onClick={(e, theDriver) => handleSelectDriver(e, driver)}>
                                    {x+1}. {driver.name}
                                    </h3>
                                    <br />
                                </div>
                            )
                            x++
                        }
                    }
                }
            }
        })
        setNonVerifiedImages([localVerifiedArray])
        setNonActiveDrivers([localArray])
        setStationChangerList(localStationChangeList)
    }

    var driverLocalList

    useEffect( () => {
        if (!logicalGate && !editGate && !offboardGate) {
            if (nonActiveDrivers.length > 0 || nonVerifiedImages.length > 0) {
                setContent(
                    <>
                        <NavigationBar title='Compliance' superUser={props.superUser ? true : false} email={props.user_email}/>
                        <div className='main_content_compliance'>
                            <div className='top_container_compliance_page'>
                                <div>
                                    <button className='compliance_add_driver_button' onClick={handleMakeOffboardSort} id='offboarded_drivers_style'>
                                        <span className='span_in_complaince_button'>OFFBOARDED DRIVERS</span> 
                                    </button>
                                </div>
                                <div className='drop_down_bar_container' id='Make_this_less'>
                                    <nav class="menu">
                                        <ol>
                                            <li className="menu-item" id="makeMeWhite"><a href="#0" id="makeMeWhite">{selectedCity}</a>
                                                <ol className="sub-menu" id="makeMeWhite">
                                                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DBS2')}><a id="makeMeWhiteli" href="#0">DBS2</a></li>
                                                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DSN1')}><a id="makeMeWhiteli" href="#0">DSN1</a></li>
                                                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DEX2')}><a id="makeMeWhiteli" href="#0">DEX2</a></li>
                                                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DXP1')}><a id="makeMeWhiteli" href="#0">DXP1</a></li>
                                                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DCF1')}><a id="makeMeWhiteli" href="#0">DCF1</a></li>
                                                </ol>
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                                <div>
                                    <button className='compliance_add_driver_button' onClick={handleMakeDriverPage} id='spaceMeLeftPlease'>
                                        <span className='span_in_complaince_button'>ADD DRIVER</span> 
                                    </button>
                                </div>
                            </div>
                            <div className='bottom_container_compliance_page'>
                                <div className='bottom_buttons_compliance_page'>
                                    <Link to='/documentsforverification' className='links' id="removeHyperLink">
                                        <button className='compliance_add_driver_button' >
                                            <h3 className='span_in_complaince_button' >Waiting for Verification</h3> 
                                        </button>
                                    </Link>
                                    <h2 className='h2Label'>Non-Verified</h2>
                                    {nonActiveDrivers}
                                </div>
                                <div className='bottom_buttons_compliance_page'>
                                    <Link to='/driverdocuments' className='links' id="removeHyperLink">
                                        <button className='compliance_add_driver_button' >
                                            <h3 className='span_in_complaince_button' >Driver Documents</h3> 
                                        </button>
                                    </Link>
                                    <h2 className='h2Label'>Verified</h2>
                                    {nonVerifiedImages}
                                </div>
                                <div className='bottom_buttons_compliance_page'>
                                    <Link to='drivercompliancecheck' className='links'id="removeHyperLink">
                                        <button className='compliance_add_driver_button' >
                                            <h3 className='span_in_complaince_button' >Driver Compliance</h3> 
                                        </button>
                                    </Link>
                                    <h2 className='h2Label'>Station Changers</h2>
                                    {stationChangerList}
                                </div>
                                <div className='bottom_buttons_compliance_page' id='last_div_compliance_page'>
                                    <Link to='/companyvans' className='links' id="removeHyperLink">
                                        <button className='compliance_add_driver_button' >
                                            <h3 className='span_in_complaince_button' >Company Vans</h3> 
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </>
                )
            } else {
                setContent(
                    <>
                        <NavigationBar title='Compliance' superUser={props.superUser ? true : false} email={props.user_email}/>
                        <div className='main_content_compliance'>
                            <div className='containerForLoader'>
                                <div class="spinner">
                                    <div class="bounce1"></div>
                                    <div class="bounce5"></div>
                                    <div class="bounce4"></div>
                                    <div class="bounce3"></div>
                                    <div class="bounce2"></div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
        }
    }, [logicalGate, editGate, offboardGate, nonVerifiedImages, nonActiveDrivers])

    return (
        <>
        {errorMessage}
            <div className='home_content'>
                {content}
            </div>
        </>
    )
}
export default Compliance